import React from "react";
import styled from "styled-components";
// Assets
import ContactImg1 from "../../assets/img/contact-1.png";

export default function Contact() {
  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Let's Get in Touch</h1>
            <p className="font13">
              We’d love to hear from you. Please fill out the form below, and we'll get back to you as soon as possible.
            </p>
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form>
                <label className="font13">First Name:</label>
                <input type="text" id="fname" name="fname" className="font20 extraBold" placeholder="Your First Name" />
                <label className="font13">Email:</label>
                <input type="email" id="email" name="email" className="font20 extraBold" placeholder="Your Email Address" />
                <label className="font13">Subject:</label>
                <input type="text" id="subject" name="subject" className="font20 extraBold" placeholder="Subject" />
                <label className="font13">Message:</label>
                <textarea rows="4" cols="50" id="message" name="message" className="font20 extraBold" placeholder="Your Message"></textarea>
              </Form>
              <SumbitWrapper className="flex">
                <ButtonInput type="submit" value="Send Message" className="pointer animate radius8" />
              </SumbitWrapper>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 flex">
  <div className="flexNullCenter flexColumn" style={{ width: "100%" }}>
    <ContactImgBox>
      <img 
        src={"https://i.pinimg.com/736x/b4/c9/54/b4c9543ab12799e283b96754872a1f7e.jpg"} 
        alt="Contact Office" 
        className="radius6" 
        style={{ width: "350px", height: "450px" }} // Adjust the size here
      />
    </ContactImgBox>
  </div>
</div>

          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 80px 0;
  background-color: #f9f9f9;
`;

const HeaderInfo = styled.div`
  padding-bottom: 40px;
  text-align: center;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const Form = styled.form`
  padding: 20px 0;
  input, textarea {
    width: 100%;
    background-color: transparent;
    border: none;
    outline: none;
    box-shadow: none;
    border-bottom: 2px solid #707070;
    height: 45px;
    margin-bottom: 20px;
    font-size: 16px;
    padding: 10px;
    transition: all 0.3s ease;
  }
  
  textarea {
    min-height: 120px;
    resize: vertical;
  }

  input:focus, textarea:focus {
    border-bottom: 2px solid #7620ff;
    box-shadow: 0 2px 10px rgba(118, 32, 255, 0.2);
  }

  @media (max-width: 860px) {
    padding: 10px;
  }
`;

const ButtonInput = styled.input`
  border: 1px solid #7620ff;
  background-color: #7620ff;
  width: 100%;
  padding: 15px;
  outline: none;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;

  :hover {
    background-color: #580cd2;
    border: 1px solid #580cd2;
  }

  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;

const ContactImgBox = styled.div`
  max-width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const SumbitWrapper = styled.div`
  text-align: center;
  margin-top: 20px;
`;

